import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

/**
 * Proves the contract pipeline end to end: FastAPI → openapi.json →
 * generated types → this call. The header shows the result as a small dot.
 */
export function useHealth() {
  return useQuery({
    queryKey: ["health"],
    queryFn: async () => {
      const { data } = await api.GET("/api/v1/health");
      return data ?? null;
    },
    retry: false,
    staleTime: 30_000,
  });
}
